import { cn } from "@/lib/utils";

interface ArrowIconProps {
    className?: string;
}

export function ArrowUpIcon( { className }: ArrowIconProps ) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            className={cn( className )}
        >
            <path
                d="M8.19542 2.22852L8.19542 13.7716M8.19542 2.22852L3.17603 6.14829M8.19542 2.22852L12.824 6.36429"
                stroke="currentColor"
                strokeWidth="1.5"
            />
        </svg>
    );
}

export function ArrowDownIcon( { className }: ArrowIconProps ) {
    return <ArrowUpIcon className={cn( className, "rotate-180" )} />;
}
